import { useState } from "react";
import { CheckCircle } from "lucide-react";
import { EpochToDateTime } from "@utils/utils";
import { Button } from "../ui/button";
import { useEffect } from "react";

const ApprovalPopup = () => {
  const [allAutomationApproval, setAllAutomationApproval] = useState<any[]>([]);

  useEffect(() => {
    const eventSource = new EventSource("/notificationPopup/");

    eventSource.onmessage = (event) => {
      if (!event?.data) return;
      try {
        const parsed = JSON.parse(event.data);
        const dataArray = Array.isArray(parsed)
          ? parsed
          : Array.isArray(parsed?.data)
            ? parsed.data
            : [];
        if (dataArray.length) setAllAutomationApproval(dataArray);
      } catch {
        console.warn("ApprovalPopup: failed to parse SSE data", event.data);
      }
    };
    eventSource.onerror = () => {
      eventSource.close();
    };
    return () => {
      eventSource.close();
    };
  }, []);

  const closePop = (approvalId: number) => {
    const approvalCard = document.querySelector(
      `.approval-card[data-id="approval-${approvalId}"]`,
    ) as HTMLElement;
    if (approvalCard) {
      approvalCard.classList.remove("slide-in-right");
      approvalCard.classList.add("slide-out-right");
      approvalCard.style.removeProperty("animation-delay");
      setTimeout(() => {
        approvalCard.remove();
      }, 500);
      setAllAutomationApproval((prev) =>
        prev.map((approval) =>
          approval.Id === approvalId ? { ...approval, read: 1 } : approval,
        ),
      );
    }
  };

  return (
    <div className="fixed top-16 right-0 z-modal-level-1 text-xs pt-2 pe-2 flex flex-col gap-1 max-w-[20vw]">
      <div>
        {allAutomationApproval &&
          allAutomationApproval.length > 0 &&
          allAutomationApproval.some(
            (approval) => (approval.read || 0) !== 1,
          ) && (
            <div className="bg-primaryGreen p-2 rounded-lg shadow-xl border flex gap-2 mb-1">
              <CheckCircle size={12} />
              <div className="font-semibold">
                You have{" "}
                {
                  allAutomationApproval.filter(
                    (approval) => (approval.read || 0) == 0,
                  ).length
                }{" "}
                pending approval{allAutomationApproval.length > 1 ? "s" : ""}
              </div>
            </div>
          )}
      </div>
      {allAutomationApproval &&
        allAutomationApproval.length > 0 &&
        allAutomationApproval.map((approval: any, index: number) => {
          if (approval.status == 1) return null;
          return (
            <div
              data-id={`approval-${approval.Id}`}
              className={`bg-background approval-card py-2 px-3 slide-in-right opacity-0 translate-x-full rounded-lg shadow-xl border flex gap-2`}
              style={{ animationDelay: `${index * 0.5}s` }}
              key={approval.Id}
            >
              <div className="flex flex-col gap-1">
                <div className="flex gap-1">
                  <div className="opacity-50">Title: </div>
                  <div>{approval.title}</div>
                </div>
                <div className="flex gap-1">
                  <div className="opacity-50">Created At: </div>
                  <div>{EpochToDateTime(approval.createdTime)}</div>
                </div>
                <div className="border-t mt-1 pt-2 flex gap-2 justify-end">
                  <Button
                    size="sm"
                    className="text-xs !h-8"
                    variant="outline"
                    onClick={() => closePop(approval.Id)}
                  >
                    Close
                  </Button>
                  <Button
                    size="sm"
                    className="text-xs !h-8"
                    variant="default"
                    onClick={() => {
                      closePop(approval.Id);
                      window.open(`/approval/?uid=${approval.uid}`, "_blank");
                    }}
                  >
                    View
                  </Button>
                </div>
              </div>
            </div>
          );
        })}
    </div>
  );
};

export default ApprovalPopup;
